export default __webpack_public_path__ + "static/media/ecosystem-vertical.ed1215c1.png";